export enum DibujoType {
  POLYGON = 'polygon',
  POLYLINE = 'polyline',
  POINT = 'point'
}

export interface Dibujo {
  dibujoId: number;
  dibujoGeometria: string;
  dibujoTipo: DibujoType;
}

export function geometryTypeToDibujoType(t: string): DibujoType {
  switch (t) {
    case 'polygon':
      return DibujoType.POLYGON;
    case 'polyline':
      return DibujoType.POLYLINE;
    case 'point':
      return DibujoType.POINT;
  }
  return null;
}
